import api from '@src/apis/api';
import { LANDING_PAGE_URL } from '@src/configs';
import { setCookie } from '@src/utils/cookie';
import { FEATURE_KEYS } from '@src/configs/featureKeys';
import useLocation from './useLocation';
import useFeatureFlags from './useFeatureFlags';

const useKCTokenHandling = () => {
  const { ip } = useLocation();
  const { getFeatureValue } = useFeatureFlags();
  const useSSO = getFeatureValue(FEATURE_KEYS.NEW_SSO_STUDIO, { ip });

  const handleReceivingTokens = (tokens) => {
    if (!tokens.token || useSSO) return;
    api.defaults.headers.common.Authorization = `Bearer ${tokens.token}`;

    setCookie({ cname: 'accessToken', cvalue: tokens.token });
    setCookie({ cname: 'refreshToken', cvalue: tokens.refreshToken });
  };

  const handleEvent = (event) => {
    if (useSSO) return;
    const redirectedEvents = [
      'onInitError',
      'onAuthRefreshError',
      'onAuthLogout',
    ];
    if (redirectedEvents.includes(event)) {
      window.location.assign(LANDING_PAGE_URL);
    }
  };

  return {
    handleReceivingTokens,
    handleEvent,
  };
};

export default useKCTokenHandling;
